import { types } from "mobx-state-tree";
import fetcher from "../utils/fetcher";

const ProjectsStore = types
  .model("ProjectsStore", {
    searchedTerm: types.frozen(),
    orders: types.frozen(),
    custOrders: types.frozen(),
    error: types.frozen(),
  })
  .actions((self) => {
    const getCustProjectOrders = async (data) => {
      self.setError("");
      const response = await fetcher().post(data).from.projects.get_cust_projects_orders();
      if (response?.status === 200 && response?.data) {
        self.setCustOrders(response.data.value);
        return response.data.value;
      } else {
        self.setError(
          response?.status === 400 || response?.status === 500
            ? response?.data?.FORM?.InterfaceErrors?.text || "error:error_failed_get_cust_orders"
            : "error:error_failed_get_cust_orders"
        );
      }
    };

    const getProjectFrame = async (data) => {
      self.setError("");
      const response = await fetcher().post(data).from.projects.get_project_frame();
      if (response?.status === 200 && response?.data) {
        self.setOrders(response.data);
        return response.data?.value?.length ? response.data?.value[0] : undefined;
      } else {
        console.log("error:error_failed_get_project_frame_req");
        self.setError("error:error_failed_get_project_frame_req");
      }
    };

    const getSupplyOrder = async (data) => {
      self.setError("");
      const response = await fetcher().post(data).from.projects.get_supply_order();
      if (response?.status === 200 && response?.data) {
        self.setOrders(response.data);
        return response.data?.value?.length ? response.data?.value[0] : undefined;
      } else {
        console.log("error:error_failed_get_supply_order_req");
        self.setError("error:error_failed_get_supply_order_req");
      }
    };

    const setProducts = async (products) => {
      if (products && Object.keys(products).length !== 0) {
        const items = products.ORDERITEMS_SUBFORM.map((p) => {
          return {
            KLINE: p.LINE,
            TYPE: "C",
            LINE: p.ORDI,
            ORDI: p.ORDI,
            id: p.ZACP_FAMEXMPARTNAME,
            description: p.PDES,
            openingType: p.ZACP_OPNTYPWEB,
            price: p.PRICE,
            length: p.AMA_SPEC16,
            width: p.AMA_SPEC17,
            quantity: p.TQUANT,
            color: p.ZACP_SPEC19,
            productionInstraction: p.ZACP_REMARK,
            buildingNo: p.ZACP_BUILDING,
            floorNo: p.ZACP_FLOOR,
            apartmentNo: p.ZACP_APARTMENT,
            balance: p.ZACP_PROJTBALANCE,
            partname: p.PARTNAME,
            mpartname: p.MPARTNAME,
            famliyName: p.ZACP_FAMEXMPARTNAME,
            type: p.ZACP_PARTTYPE,
          };
        });

        return items;
      }
    };

    const getFrameDetails = async (data) => {
      self.setError("");
      const response = await fetcher().post(data).from.projects.get_frame_details();
      if (response?.status === 200 && response?.data) {
        const products = await setProducts(response.data?.value[0]);
        return { ...response.data?.value[0], products };
      } else {
        self.setError(
          response?.status === 400 || response?.status === 500
            ? response?.data?.FORM?.InterfaceErrors?.text || "error:error_failed_get_frame_details"
            : "error:error_failed_get_frame_details"
        );
      }
    };

    const getSupplyOrders = async (data) => {
      self.setError("");
      const response = await fetcher().post(data).from.projects.get_supply_orders();
      if (response?.status === 200 && response?.data) {
        // self.setOrders(response.data);
        return response.data.value;
      } else {
        self.setError(
          response?.status === 400 || response?.status === 500
            ? response?.data?.FORM?.InterfaceErrors?.text || "error:error_failed_get_supply_orders"
            : "error:error_failed_get_supply_orders"
        );
      }
    };

    const getSupplyOrderItems = async (data) => {
      self.setError("");
      const response = await fetcher().post(data).from.projects.get_supply_order_items();
      if (response?.status === 200 && response?.data) {
        // self.setOrders(response.data);
        return response.data.value;
      } else {
        self.setError(
          response?.status === 400 || response?.status === 500
            ? response?.data?.FORM?.InterfaceErrors?.text || "error:error_failed_get_supply_orders"
            : "error:error_failed_get_supply_orders"
        );
      }
    };

    const getItemDetails = async (data) => {
      self.setError("");
      const details = await fetcher().post(data).from.projects.get_item_details();
      if (details?.status === 200 && details?.data) {
        return details.data;
      } else {
        console.log("error:error_failed_get_item_details_req");
        self.setError("error:error_failed_get_item_details_req");
      }
    };

    const setError = (error) => {
      self.error = error;
    };

    const setOrders = (orders) => {
      self.orders = orders;
    };

    const setCustOrders = (orders) => {
      self.custOrders = orders;
    };

    const setSearchedTerm = async (term) => {
      self.searchedTerm = term;
    };

    return {
      setError,
      setOrders,
      getItemDetails,
      setCustOrders,
      getSupplyOrders,
      getProjectFrame,
      getFrameDetails,
      getCustProjectOrders,
      setSearchedTerm,
      getSupplyOrderItems,
      getSupplyOrder,
    };
  })
  .views((self) => ({
    get isError() {
      return !!self.error;
    },
  }));

const projectsStore = ProjectsStore.create({
  searchedTerm: "",
  error: "",
  orders: [],
  custOrders: [],
});

export default projectsStore;
